export default () => ({
  availableFiltersOptions: {},
  selectedCategories: [],
  selectedCategory: {}
})
